module.exports = __webpack_public_path__ + "img/payment.3ff9cd62.svg";